'use client';

import PriceRangeFilter from '@modules/store/components/price-range-filter';
import SortProducts, {
  type SortOptions,
} from '@modules/store/components/refinement-list/sort-products';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

type ProductToolbarProps = {
  sortBy: SortOptions;
  productCount: number;
  minPrice?: number;
  maxPrice?: number;
};

const ProductToolbar = ({
  sortBy,
  productCount,
  minPrice,
  maxPrice,
}: ProductToolbarProps) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams);
      params.set(name, value);
      params.set('page', '1');
      return params.toString();
    },
    [searchParams],
  );

  const setQueryParams = (name: string, value: string) => {
    const query = createQueryString(name, value);
    router.push(`${pathname}?${query}`);
  };

  return (
    <div className="flex items-center justify-between mb-6 gap-4 flex-wrap">
      <p className="text-sm text-fg-neutral-soft">
        Showing {productCount} {productCount === 1 ? 'product' : 'products'}
      </p>
      <div className="flex items-center gap-3">
        <PriceRangeFilter minPrice={minPrice} maxPrice={maxPrice} />
        <SortProducts sortBy={sortBy} setQueryParams={setQueryParams} />
      </div>
    </div>
  );
};

export default ProductToolbar;
